<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="categoryName" >
        <span slot="label" ><a-tooltip>{{ $t('分类名称') }}<template slot="title">{{ $t('分类名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.categoryName" :maxLength="64" :placeholder="$t('请输入')+'分类名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="categoryIcon" >
        <span slot="label" ><a-tooltip>{{ $t('分类图标URL') }}<template slot="title">{{ $t('分类图标URL') }}</template></a-tooltip> </span>
        <oss-upload-single :height="100" :width="100" v-model="form.categoryIcon" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="categoryCover" >
        <span slot="label" ><a-tooltip>{{ $t('分类封面URL') }}<template slot="title">{{ $t('分类封面URL') }}</template></a-tooltip> </span>
        <oss-upload-single :height="200" :width="360" v-model="form.categoryCover" prefix="community" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="sort" >
        <span slot="label" ><a-tooltip>{{ $t('排序值，值越大越靠前') }}<template slot="title">{{ $t('排序值，值越大越靠前') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.sort" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'排序值，值越大越靠前'" />
      </a-form-model-item>
      <a-form-model-item prop="postCategory" >
        <span slot="label" ><a-tooltip>{{ $t('关联帖子分类') }}<template slot="title">{{ $t('关联帖子分类：10-漫展，20-日常，30-种草，40-情绪，50-游戏，60-动漫') }}</template></a-tooltip> </span>
        <a-select v-model="form.postCategory" :placeholder="$t('请选择')+'关联帖子分类'" allow-clear>
          <a-select-option v-for="(item, index) in customDict.GroupPostCategoryEnum" :key="index" :value="item.type">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>

      
      <a-form-model-item prop="remark" >
        <span slot="label" ><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupCategory, addCommunityGroupCategory, updateCommunityGroupCategory } from '@/api/community/communityGroup/communityGroupCategory'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
      OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        categoryName: null,
        categoryIcon: null,
        categoryCover: null,
        sort: null,
        postCategory: null,
        remark: null,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          categoryName: [{ required: true, message: this.$t('分类名称') + this.$t('不能为空'), trigger: 'blur' }],
          sort: [{ required: true, message: this.$t('排序值，值越大越靠前') + this.$t('不能为空'), trigger: 'blur' }],
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        categoryName: null,
        categoryIcon: null,
        categoryCover: null,
        sort: null,
        postCategory: null,
        remark: null,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupCategory({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupCategory(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupCategory(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>

